export const googleKeys = {
  all: ['google'] as const,
  oauthStatus: () => [...googleKeys.all, 'oauthStatus'] as const,
};
